/**
 * useBostaCikis — etkinliksiz kalan oturumu kapatır (backlog #646). Dokunma / tıklama / tuş / kaydırma her seferinde süreyi sıfırlar; süre dolunca `onBitti` çağrılır.
 * Paylaşılan bir telefonda açık kalan kişi sayfası kimlik bilgisi gösterir; bu yüzden süre sunucunun söylediğiyle (idle_timeout_seconds) aynıdır.
 */
import { useEffect, useRef } from 'react';

const OLAYLAR = ['pointerdown', 'keydown', 'touchstart', 'scroll'];

export default function useBostaCikis(saniye, onBitti, aktif) {
  const sonRef = useRef(onBitti);
  // the latest callback is kept in an effect, not during render (react-hooks/refs)
  useEffect(() => { sonRef.current = onBitti; });

  useEffect(() => {
    if (!aktif || !(saniye > 0)) return undefined;
    let zaman = setTimeout(() => sonRef.current(), saniye * 1000);
    const sifirla = () => {
      clearTimeout(zaman);
      zaman = setTimeout(() => sonRef.current(), saniye * 1000);
    };
    OLAYLAR.forEach((o) => window.addEventListener(o, sifirla, { passive: true }));
    return () => {
      clearTimeout(zaman);
      OLAYLAR.forEach((o) => window.removeEventListener(o, sifirla));
    };
  }, [saniye, aktif]);
}
